import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import { from, of } from 'rxjs';
import { concatMap, delay, catchError } from 'rxjs/operators';

interface RepLetterGroup {
  repName: string;
  repMobileNo: string;
  district: string;
  data: any[];
  totalAmt: number;
  totalUnpaid: number;
  isWhatsAppSent?: boolean;
  isSendingWhatsApp?: boolean;
}

@Component({
  selector: 'app-send-reminder-letter-rep-book',
  templateUrl: './send-reminder-letter-rep-book.component.html',
  styleUrl: './send-reminder-letter-rep-book.component.scss'
})
export class SendReminderLetterRepBookComponent {
  currentDate: Date = new Date();

  /* ================= GROUPED (ONE ENTRY PER REP) ================= */
  reportGroups: RepLetterGroup[] = [];

  isEditMode: boolean = false;
  isSaving: boolean = false;

  reportType: any;
  startDate: any;
  endDate: any;
  repName: any;
  offRepName: any;
  issueDates: any;
  issueDates1: any;
  sendingAllWhatsAppReminders = false;

  show = false;

  /* ================= LETTER TEMPLATE ================= */

  letterBodyText = {
    template_name: 'send-reminder2',
    subject_line: '',
    greeting: '',
    paragraph1: '',
    paragraph2: '',
    paragraph3: '',
    details_heading: '',
    closing_text: ''
  };
  

  defaultLetterText = {
    template_name: 'send-reminder1',
    subject_line: 'विषय : मागील पुस्तक/ग्रंथ येणे बाकी सदंर्भात स्मरण पत्र .........',
    greeting: 'सस्नेह नमस्कार',
    paragraph1: 'सा.विवेक हे महाराष्ट्रातील सर्व महत्वाच्या घडामोडींचा आढावा घेणारे वैचारिक साप्ताहिक आहे. प्रसारमाध्यमातून सामाजिक परिवर्तनाचे राष्ट्रीय कार्य गेली 78 वर्षे अखंडीतपणे सुुरू आहे. हा प्रवास आपल्याकडून सा.विवेकला वेळोवेळी मिळत असलेल्या अर्थ पूर्ण सहकार्यामुळेच शक्य होत आहे. या करीता आपले मन:पूर्वक धन्यवाद !',
    paragraph2: 'आपण जाणताच की, कोणत्याही राजकीय अथवा ोठ्या औद्योगिक समूहाचे आर्थिक पाठबळ नसताना विवेक केवळ आपल्यासारख राष्ट्रभक्त हितचिंतकांच्या आश्वासक पाठिंब्यामुळेच सुरू आहे. याचा विवेक समूहाला सार्थ अभिमान आहे. मागील अंकात आपली, आपल्या आस्थापनाची जाहिरात प्रकाशित करण्यात आली होती.  मात्र ही दे रक्क कार्यालयात अद्याप जमा झालेली नाही.',
    paragraph3: 'अशा प्रकारची देय रक्कम कार्यालयात जमा न होणे हे प्रसारमाध्यम क्षेत्रात काम करणार्‍या विवेक सारख सामाजिक संस्थेला परवडणारे नसते, हे आपण जाणताच! आपली दे रक्कम आपल्या व्यग्र कामकाजामुळे राहून गेली असावी असे आम्हाला वाटते. तरी आपणास नम्र विनंती आहे की, ही देय रक्कम कार्यालयात लवकरात लवकर जमा करावी. धन्यवाद !',
    details_heading: 'येणे बाकी तपशील खालील प्रमाणे आहे.',
    closing_text: ''
  };

  constructor(
    private dialogRef: MatDialogRef<SendReminderLetterRepBookComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) { }

  /* ================= INIT ================= */

  ngOnInit(): void {
    this.reportType = this.data?.reportType;
    this.startDate = this.data?.startDate || '';
    this.endDate = this.data?.endDate || '';
    this.repName = this.data?.repName;
    this.offRepName = this.data?.offRepName;
    this.issueDates1 = this.data?.issue_date;

    this.loadLetterTemplate();

    const req = {
      rep_name: this.repName,
      start_date: this.startDate,
      end_date: this.endDate,
      off_rep_name: this.offRepName,
      issue_name: '',
      issue_date: this.issueDates1
    };

    this.service.getpendingreceipt2(req).subscribe((res: any) => {

      /* 🔥 API RETURNS DATA GROUPED BY rep_name:
         [{ rep_name: 'X', data: [ {invoice_no, invoice_date, ...}, ... ] }, ...]
         We build ONE letter group per rep so each rep gets its own printed page. */

      const records = res?.data || [];

      const grouped: any = {};

      records.forEach((item: any) => {

        const repName = item.rep_name || '';

        if (!grouped[repName]) {
          grouped[repName] = {
            repName: item.rep_name,
            repMobileNo: item.rep_mobile_no,   // ✅ WhatsApp mobile
            district: item.district || '',
            data: [],
            totalAmt: 0,
            totalUnpaid: 0
          };
        }

        const row = {
          invoice_no: item.invoice_no,
          invoice_date: item.invoice_date,
          invoice_total: Number(item.invoice_total) || 0,
          unpaid_amt: Number(item.unpaid_amt) || 0,
          book_seller_name: item.book_seller_name,
          mobile_no: item.mobile_no,           // ✅ only table display
          rep_mobile_no: item.rep_mobile_no,
          district: item.district || ''
        };

        grouped[repName].data.push(row);
        grouped[repName].totalAmt += row.invoice_total;
        grouped[repName].totalUnpaid += row.unpaid_amt;
      });

      this.reportGroups = Object.values(grouped);

      this.cdr.detectChanges();
    });
  }



  /* ================= LETTER TEMPLATE ================= */

  loadLetterTemplate(): void {
    this.service.getLetterTemplate('send-reminder2').subscribe(
      (res: any) => {
        if (res?.success && res?.data) {
          const d = res.data;
          this.letterBodyText = {
            template_name: d.template_name || 'send-reminder2',
            subject_line: d.subject_line || this.defaultLetterText.subject_line,
            greeting: d.greeting || this.defaultLetterText.greeting,
            paragraph1: d.paragraph1 || this.defaultLetterText.paragraph1,
            paragraph2: d.paragraph2 || this.defaultLetterText.paragraph2,
            paragraph3: d.paragraph3 || this.defaultLetterText.paragraph3,
            details_heading: d.details_heading || this.defaultLetterText.details_heading,
            closing_text: d.closing_text || this.defaultLetterText.closing_text
          };
        } else {
          this.letterBodyText = { ...this.defaultLetterText };
        }
        this.cdr.detectChanges();
      },
      () => {
        this.letterBodyText = { ...this.defaultLetterText };
        this.cdr.detectChanges();
      }
    );
  }

  toggleEditMode(): void {
    this.isEditMode = !this.isEditMode;
    if (!this.isEditMode) {
      this.loadLetterTemplate();
    }
  }

  saveLetterTemplate(): void {
    this.isSaving = true;
    this.service.saveLetterTemplate(this.letterBodyText).subscribe(
      (res: any) => {
        this.isSaving = false;
        if (res?.success) {
          alert('Template saved successfully');
          this.isEditMode = false;
        } else {
          alert('Error saving template');
        }
      },
      () => {
        this.isSaving = false;
        alert('Error saving template');
      }
    );
  }


  resetToDefault(): void {
    if (confirm('Reset to default template?')) {
      this.letterBodyText = { ...this.defaultLetterText };
      this.saveLetterTemplate();
    }
  }

  /* ================= PRINT (ONE PAGE PER REP) ================= */

  printPage(): void {
    const printSection = document.getElementById('print-section');
    if (!printSection) {
      console.error('Print section not found!');
      return;
    }

    const clone = printSection.cloneNode(true) as HTMLElement;
    const origin = window.location.origin;

    // Force absolute src on every image (logo, QR code, etc.)
    clone.querySelectorAll('img').forEach((imgEl) => {
      const el = imgEl as HTMLImageElement;
      if (el.src) {
        el.setAttribute('src', el.src); // el.src getter already returns the resolved absolute URL
      }
    });

    const printContent = clone.outerHTML;

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
    if (!printWindow) {
      console.error('Failed to open print window. Check popup blocker.');
      alert('Popup blocked. Please allow popups for this site to print.');
      return;
    }

    printWindow.document.open();
    printWindow.document.write(`
    <html>
      <head>
        <meta charset="UTF-8">
        <base href="${origin}/">
        <title>स्मरणपत्र</title>
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }

          body {
            font-family: 'Noto Sans Devanagari', Arial, sans-serif;
            color: #000 !important;
            background: white;
            font-size: 17px;
          }

          @page { size: A4 portrait; margin: 10mm 12mm; }

          @media print {
            body { width: 210mm; margin: 0; padding: 0; }
            .no-print, button, .edit-controls { display: none !important; }
          }

          .rep-letter-block { page-break-after: always; }
          .rep-letter-block:last-child { page-break-after: auto; }

          /* Border around the whole printed receipt/letter */
          .reminder-container {
            max-width: 210mm;
            margin: 0 auto;
            padding: 14px;
            background: #fff;
            font-family: 'Noto Sans Devanagari', Arial, sans-serif;
            color: #000 !important;
            page-break-inside: avoid;
            border: 2px solid #000;
          }

          .header-section { padding-bottom: 8px; color: #000 !important; page-break-inside: avoid; }
          .header-content { color: #000 !important; }
          .header-top { display: flex; justify-content: space-between; align-items: flex-start; padding-bottom: 6px; }
          .organization-info { flex: 1; text-align: right; margin-top: 40px; line-height: 1.4; margin-right: 40px; }
          .organization-name { font-size: 23px; font-weight: bold; margin: 0 0 3px 0; color: #000; text-align: right; }
          .registration-number { font-size: 16px; color: #000 !important; text-align: right; display: block; margin-bottom: -15px; }
          .office-label, .contact-label { font-weight: bold; color: #000 !important; margin-bottom: -50px; }
          .header-logo { display: flex; align-items: center; justify-content: center; width: 100px; margin-left: 20px; }
          .header-logo img { margin-right: 50px; max-width: 170px; margin-top: 14px; margin-bottom: 10px; }
          .header-divider { margin: 1px 0; border: none; border-top: 1px solid #333; }
          .office-details-single { font-size: 16px; line-height: 1.4; color: #000 !important; text-align: left; }

          .header-title-center { text-align: center; font-weight: bold; font-size: 18px; margin: 8px 0; text-decoration: underline; color: #000 !important; }

          .recipient-section { display: flex; justify-content: space-between; padding: 10px 0; page-break-inside: avoid; }
          .recipient-address { text-align: left; flex: 1; }
          .date-section { text-align: right; color: #000 !important; }
          .field-label { font-weight: bold; font-size: 18px; color: #000 !important; }
          .field-row { margin: 4px 0; font-size: 15px; }
          .field-value { font-size: 18px; color: #000 !important; }

          .content-section { padding: 10px 0; text-align: left; }
          .subject-line { text-align: center; font-weight: bold; font-size: 18px; margin-bottom: 8px; color: #000 !important; }
          .greeting { text-align: left; font-weight: normal; font-size: 18px; margin-bottom: 8px; color: #000 !important; }
          .letter-body { font-size: 15px; line-height: 1.5; text-align: justify; color: #000 !important; }
          .letter-body p { margin: 6px 0; text-indent: 42px; color: #000 !important; }
          .letter-body > div { margin-bottom: 8px; }
          .details-heading { font-weight: bold; margin: 10px 0 6px 0 !important; color: #000 !important; text-indent: 0 !important; }

          .table-wrapper { margin: 10px 0; overflow-x: auto; color: #000 !important; page-break-inside: auto; }
          .details-table { width: 100%; border-collapse: collapse; font-size: 16px; color: #000 !important; }
          .details-table th, .details-table td { border: 1px solid #333; padding: 5px 6px; text-align: center; color: #000 !important; }
          .details-table th { background-color: #f0f0f0; font-weight: bold; font-size: 17px; color: #000 !important; }
          .details-table tbody tr { page-break-inside: avoid; }
          .total-row { font-weight: bold; background-color: #f5f5f5; color: #000 !important; }
          .total-row td { font-weight: bold; }

          .closing-text { margin: 10px 0; font-size: 17px; text-indent: 40px; color: #000 !important; }

          .row { display: flex; margin-top: 15px; page-break-inside: avoid; }
          .col-7 { flex: 0 0 58.33%; max-width: 58.33%; padding-right: 10px; }
          .col-7 > div { border: 1px solid #000; padding: 10px; height: 100%; display: flex; justify-content: space-between; align-items: flex-start; }
          .col-7 img { width: 100px !important; height: 100px !important; }
          .col-5 { flex: 0 0 41.67%; max-width: 41.67%; display: flex; align-items: flex-end; justify-content: center; flex-direction: column; padding-right: 15px; }
          .col-5 p:first-child { margin-top: 40px !important; font-size: 17px; }
          .col-5 p:last-child { margin-top: 60px !important; font-size: 17px; }

          .signature-section { text-align: right; margin-top: 40px; margin: 20px 0 10px 0; font-size: 17px; }
          .signature-section p { margin: 3px 0; margin-top: 40px; color: #000 !important; }

          .no-print, button, .edit-controls, textarea, input[type="text"] { display: none !important; }
          .subject-line span, .greeting span, .letter-body p, .details-heading { display: block; }
        </style>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
  `);
    printWindow.document.close();

    // Close the popup automatically once the print dialog is dismissed
    // (works in Chrome/Edge/Firefox). Fallback timeout covers browsers
    // that don't fire afterprint reliably in a popup.
    let closed = false;
    const safeClose = () => {
      if (closed) return;
      closed = true;
      printWindow.close();
    };
    printWindow.addEventListener('afterprint', safeClose);

    const triggerPrint = () => {
      printWindow.focus();
      printWindow.print();
      // Fallback in case afterprint never fires
      setTimeout(safeClose, 2000);
    };

    // Wait for every image in the popup to load (or fail) before printing,
    // capped at 3s so a broken image URL can't block printing indefinitely.
    const images = Array.from(printWindow.document.images);
    if (images.length === 0) {
      triggerPrint();
      return;
    }

    let loadedCount = 0;
    const total = images.length;
    const onAnyImageSettled = () => {
      loadedCount++;
      if (loadedCount >= total) {
        triggerPrint();
      }
    };

    images.forEach((img) => {
      if (img.complete) {
        onAnyImageSettled();
      } else {
        img.addEventListener('load', onAnyImageSettled, { once: true });
        img.addEventListener('error', onAnyImageSettled, { once: true });
      }
    });

    // Absolute fallback: never wait more than 3s for images
    setTimeout(() => {
      if (loadedCount < total) {
        triggerPrint();
      }
    }, 3000);
  }


  // sendWhatsAppReminderRep(group: any): void {

  //   if (!group) {
  //     alert('Rep data not found');
  //     return;
  //   }

  //   if (!group.repMobileNo) {
  //     alert('Mobile number not found for ' + group.repName);
  //     return;
  //   }

  //   const payload = {
  //     mobile: String(group.repMobileNo),
  //     campaignName: 'outstanding',
  //     templateParams: [
  //       group.repName,
  //       group.district || '',
  //       this.formatDate(this.currentDate),
  //       Number(group.totalUnpaid).toFixed(2)
  //     ]
  //   };

  //   this.service.sendWhatsAppReceipt(payload).subscribe({
  //     next: () => alert('WhatsApp sent successfully'),
  //     error: (err: any) => {
  //       console.error('WhatsApp failed:', err);
  //       alert('WhatsApp failed');
  //     }
  //   });
  // }

//   sendWhatsAppReminderRep(group: any): void {

//   if (!group) {
//     alert('Rep data not found');
//     return;
//   }

//   if (!group.repMobileNo) {
//     alert('Mobile number not found for ' + group.repName);
//     return;
//   }

//   const payload = {
//     mobile: String(group.repMobileNo),
//     campaignName: 'outstanding',
//     templateParams: [
//       group.repName,
//       group.district || '',
//       this.formatDate(this.currentDate),
//       Number(group.totalUnpaid).toFixed(2)
//     ]
//   };

//   this.service.sendWhatsAppReceipt(payload).subscribe({
//     next: () => {
//       alert('WhatsApp sent successfully');
//       group.isWhatsAppSent = true; // Hide only this group's button
//     },
//     error: (err: any) => {
//       console.error('WhatsApp failed:', err);
//       alert('WhatsApp failed');
//     }
//   });
// }


  formatDate(date: Date): string {
    const d = ('0' + date.getDate()).slice(-2);
    const m = ('0' + (date.getMonth() + 1)).slice(-2);
    const y = date.getFullYear();

    return `${d}/${m}/${y}`;
  }

  // ================= BUILD WHATSAPP PAYLOAD (shared by single + bulk) =================
private buildWhatsAppReminderPayload(group: any): { mobile: string; campaignName: string; templateParams: string[] } | null {

  if (!group?.repMobileNo) {
    return null;
  }

  return {
    mobile: String(group.repMobileNo),
    campaignName: 'outstanding',
    templateParams: [
      group.repName,
      group.district || '',
      this.formatDate(this.currentDate),
      Number(group.totalUnpaid).toFixed(2)
    ]
  };
}

// ================= SEND SINGLE REMINDER (now uses shared payload builder) =================
sendWhatsAppReminderRep(group: any): void {

  if (!group) {
    alert('Rep data not found');
    return;
  }

  const payload = this.buildWhatsAppReminderPayload(group);

  if (!payload) {
    alert('Mobile number not found for ' + group.repName);
    return;
  }

  group.isSendingWhatsApp = true;

  this.service.sendWhatsAppReceipt(payload).subscribe({
    next: () => {
      group.isSendingWhatsApp = false;
      alert('WhatsApp sent successfully');
      group.isWhatsAppSent = true;
    },
    error: (err: any) => {
      group.isSendingWhatsApp = false;
      console.error('WhatsApp failed:', err);
      alert('WhatsApp failed');
    }
  });
}

// ================= SEND ALL REMINDERS (bulk, one-shot) =================
sendAllWhatsAppReminders(): void {

  if (!this.reportGroups.length) {
    alert('पाठवण्यासाठी कोणतेही प्रतिनिधी उपलब्ध नाहीत.');
    return;
  }

  if (!confirm(`सर्व ${this.reportGroups.length} प्रतिनिधींना स्मरणपत्र WhatsApp पाठवायचे आहे का?`)) return;

  const skipped: string[] = [];
  const failed: string[] = [];
  const sent: string[] = [];

  const jobs = this.reportGroups
    .filter(g => !g.isWhatsAppSent) // don't re-send to ones already marked sent
    .map(group => ({ group, payload: this.buildWhatsAppReminderPayload(group) }))
    .filter(job => {
      if (!job.payload) {
        skipped.push(job.group.repName);
        return false;
      }
      return true;
    });

  if (!jobs.length) {
    alert('कोणत्याही प्रतिनिधीसाठी वैध मोबाईल नंबर उपलब्ध नाही.');
    return;
  }

  this.sendingAllWhatsAppReminders = true;
  jobs.forEach(job => job.group.isSendingWhatsApp = true);

  from(jobs).pipe(
    concatMap(job =>
      this.service.sendWhatsAppReceipt(job.payload!).pipe(
        delay(400), // gap between sends to avoid rate-limiting
        catchError(err => {
          console.error(`WhatsApp failed for ${job.group.repName}:`, err);
          failed.push(job.group.repName);
          return of(null);
        }),
        concatMap(res => {
          job.group.isSendingWhatsApp = false;
          if (res !== null) {
            job.group.isWhatsAppSent = true;
            sent.push(job.group.repName);
          }
          return of(res);
        })
      )
    )
  ).subscribe({
    complete: () => {
      this.sendingAllWhatsAppReminders = false;
      this.cdr.detectChanges();

      let msg = `✅ पाठवले: ${sent.length}`;
      if (failed.length) msg += `\n❌ अयशस्वी: ${failed.length} (${failed.join(', ')})`;
      if (skipped.length) msg += `\n⚠️ मोबाईल नंबर नाही: ${skipped.length} (${skipped.join(', ')})`;

      alert(msg);
    }
  });
}


}